export default __webpack_public_path__ + "static/media/not_found_image.a8a93a19.png";